// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.attachments-section__wrapper[data-v-65cfcce1] {\n  margin-top: 20px;\n  margin-bottom: -10px;\n}\n", ""]);
// Exports
module.exports = exports;
